import React from 'react';
import styled from 'styled-components';
import DownArrow from './DownArrow';
import JoevLogo from './JoevLogo';

export const StyledWelcomeContainer = styled.div`
  position: relative;
  height: 100vh;
  height: 100svh;
  min-height: 100vh;
  min-height: 100svh;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  padding: 0 16px;
`;

export const StyledReleaseContainer = styled.div`
  position: relative;
  height: 100vh;
  height: 100svh;
  min-height: 100vh;
  min-height: 100svh;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;

  @media (max-width: 768px) {
    height: auto;
    min-height: 100svh;
    overflow: visible;
    padding: 7vh 0 5vh;
    justify-content: center;
  }
`;

export const StyledSocialIcon = styled.div`
  width: 64px;
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 4px;
  opacity: 0.9;
  transition: all 0.5s ease;
  border-radius: 8px;
  z-index: 5000;
  cursor: pointer;

  img {
    display: block;
    width: 28px;
    height: 28px;
    object-fit: contain;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;

    img {
      width: 24px;
      height: 24px;
    }
  }

  @media (max-width: 480px) {
    width: 52px;
    height: 52px;

    img {
      width: 22px;
      height: 22px;
    }
  }

  @media (max-width: 768px) {
    &:hover {
      transform: scale(1.2) !important;
      transition: all 0.5s ease;
      box-shadow: 0px 0px 4px 4px rgba(255, 255, 255, 0.4);
      z-index: 5500;
      opacity: 1;
    }
  }
  @media (min-width: 768px) {
    &:hover {
      transform: scale(1.4) !important;
      transition: all 0.5s ease;
      box-shadow: 0px 0px 4px 4px rgba(255, 255, 255, 0.4);
      z-index: 5500;
      opacity: 1;
    }
  }
`;

export const StyledJoevLogo = styled(JoevLogo)`
  width: clamp(180px, 56vw, 280px);
  position: relative;
  opacity: 1;
  z-index: 5500;
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  user-select: none;

  &:focus,
  &:focus-visible {
    outline: none;
  }
`;

export const StyledDownArrow = styled(DownArrow)`
  width: clamp(120px, 34vw, 180px);
  position: absolute;
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 3vh;
  opacity: 1;
  z-index: 5500;
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  user-select: none;

  &:focus,
  &:focus-visible {
    outline: none;
  }
`;

export const StyledH1Bold = styled.h3`
  padding: 0px 1rem;
  font-weight: bold;
  color: rgba(255, 0, 255, 1);
  text-align: center;
  font-variant-caps: all-petite-caps;
  z-index: 5100;
  position: relative;
  width: 100%;
  margin: 0;
`;

export const StyledH1 = styled.h1`
  padding: 0.2em 0rem 0 0;
  color: #fff;
  line-height: 0.75em;
  font-variant-caps: all-petite-caps;
  transition: all 0.5s ease;
`;

export const StyledCol = styled.div`
  max-width: 100%;
  transform: translate(0);
  background-color: rgba(255, 0, 255, 0.4);
  transition: all 2s ease-out;
`;

export const StyledP = styled.p`
  font-variant-caps: all-petite-caps;
  padding: 0px 1rem;
  font-size: clamp(1.25rem, 4.8vw, 2rem);
  margin: 0px;
  color: #fff;
`;

export const StyledCaption = styled(StyledP)`
  font-variant-caps: all-petite-caps;
  padding: 0px 1rem;
  font-size: clamp(1rem, 3.8vw, 1.5rem);
  color: #fff;
`;

export const StyledIconP = styled.p`
  font-size: 0.6em;
  color: #fff;
  text-align: center;
  line-height: 1.1;
  margin: 2px 0 0 0;
  padding: 0;
  font-variant-caps: all-petite-caps;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 480px) {
    font-size: 0.52rem;
    margin-top: 1px;
  }
`;

export const Spacer = styled.p`
  height: 10vh;
  display: block;
  overflow: hidden;
  margin: 0;
`;

export const StyledReleaseImage = styled.div`
  margin: 0 auto clamp(12px, 2.5vh, 28px);
  background-size: contain;
  background-position: center bottom;
  background-repeat: no-repeat;
  width: min(90vw, 540px);
  height: clamp(200px, 44vh, 480px);
  opacity: 0.6;
  transition: all 2s ease;
  transform: scale(0.9);
  cursor: pointer;
  position: relative;
  z-index: 6000;

  @media (max-width: 768px) {
    margin: 0 auto clamp(10px, 2vh, 20px);
    transform: scale(0.98);
    height: clamp(180px, 36vh, 340px);
  }
`;

export const StyledReleaseBgRow = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.8;
  overflow: hidden;
  pointer-events: none;
`;

const StyledComponents = {
  Spacer,
  StyledJoevLogo,
  StyledDownArrow,
  StyledH1,
  StyledCol,
  StyledH1Bold,
  StyledP,
  StyledCaption,
  StyledIconP,
  StyledReleaseImage,
  StyledWelcomeContainer,
  StyledReleaseContainer,
  StyledReleaseBgRow,
  StyledSocialIcon,
};

export default StyledComponents;
